// Dialog: conferma sovrascrittura di una ricetta esistente con le nuove quantità.
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

const ConfermaSovrascritturaDialog = ({ open, onOpenChange, ricettaNome, loading, onConferma }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm mx-4 rounded-3xl bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-foreground text-base">Conferma sovrascrittura</DialogTitle>
          <DialogDescription className="sr-only">Conferma la sostituzione della ricetta esistente con le nuove quantità.</DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <p className="text-muted-foreground text-sm leading-relaxed">
            Questa modifica <strong className="text-red-500">elimina e sostituisce</strong> la vecchia ricetta "<strong className="text-foreground">{ricettaNome}</strong>" con le nuove quantita.
          </p>
          <p className="text-muted-foreground text-xs mt-2">Questa azione non è reversibile.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1 border-border text-foreground" data-testid="cancel-overwrite-button">
            Annulla
          </Button>
          <Button onClick={onConferma} disabled={loading} className="flex-1 bg-red-600 hover:bg-red-700 text-white" data-testid="confirm-overwrite-btn">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sovrascrivi"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfermaSovrascritturaDialog;
